import React, { Component } from "react";
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';
import InputGroup from 'react-bootstrap/InputGroup';
import Row from 'react-bootstrap/Row';
import AuthService from "../services/auth-service";
import { Link, Navigate, useLocation } from "react-router-dom";

class Login extends React.Component {
  constructor(props) {    
    super(props); 
    this.state = { 
      validated: false,
      username: "",
      password: "",
      loading: false,
      loginValid: false,
      errorMessage: null
    };    
  }
  onChangeUsername(e) {
    this.setState({
      username: e.target.value
    });
  }
  onChangePassword(e) {
    this.setState({
      password: e.target.value
    });
  }
  handleSubmit(e) {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      console.log("data form not valid!")
      this.setState({ 
        validated: true,
      })
    } else {
      console.log("data form ok")
      this.setState({ 
        loading: true,
      })
      AuthService.ServiceUserLogin(this.state.username, this.state.password).then(data => {
        if (data.is_valid) {
          console.log("login ok, jwt:")
          console.log(data.jwt)
          this.props.loginHandler()
          this.setState({ 
            loginValid: true 
          })          
        } else {
          this.setState({ 
            loading: false,
            errorMessage: "Invalid data!",
            validated: false,
          })
        }
      }).catch(error => {
        this.setState({ 
          loading: false,
          errorMessage: "Error trying to login!",
          validated: false,
        })
      })
    }    
  }
  render() {    
    return (
      <Form noValidate validated={this.state.validated} onSubmit={e => this.handleSubmit(e)}>

        <Row style={{ marginTop: "15px" }}> 
          <Col md="4"></Col>
          <Col md="4">

            {this.state.loginValid && (
              // Primary: use react-router state `location.state.from` injected by UserAuthRequired.
              // Fallback: use `next` query param for backward compatibility. Final fallback is '/'.
              (() => {
                try {
                  const loc = this.props.location || window.location;
                  // state.from if provided (preferred)
                  const stateFrom = (this.props.location && this.props.location.state && this.props.location.state.from) || (loc.state && loc.state.from);
                  if (stateFrom) return <Navigate to={stateFrom} replace={true} />

                  // fallback to query 'next'
                  const params = new URLSearchParams(this.props.location ? this.props.location.search : window.location.search);
                  const next = params.get('next');
                  if (next) {
                    try {
                      const decoded = decodeURIComponent(next);
                      return <Navigate to={decoded} replace={true} />
                    } catch (e) {
                      return <Navigate to={next} replace={true} />
                    }
                  }
                } catch (e) {
                  // ignore and fallback to /
                }
                return <Navigate to="/" replace={true} />
              })()
            )}

            <Row className="mb-3">          
              <Form.Group as={Col} controlId="validationUsername">
                <Form.Label>Username</Form.Label>
                <Form.Control 
                  required
                  type="text" 
                  placeholder="Username" 
                  disabled={this.state.loading}
                  onChange={e => this.onChangeUsername(e)} />
                {/* <Form.Text className="text-muted">
                  We'll never share your username with anyone else.
                </Form.Text> */}
                <Form.Control.Feedback type="invalid">
                  Please enter a username.
                </Form.Control.Feedback>
              </Form.Group>          
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} controlId="validationPassword">
                <Form.Label>Password</Form.Label>
                <Form.Control 
                  required 
                  type="password" 
                  placeholder="Password" 
                  disabled={this.state.loading}
                  onChange={e => this.onChangePassword(e)} />
                <Form.Control.Feedback type="invalid">
                  Please enter a password.
                </Form.Control.Feedback>
              </Form.Group>
              <Link to={"/service/user/reset/password"}>Forgot something? Click here to reset your password</Link>
            </Row>

            <Row className="mb-3">
              <Col>
                <Button type="submit">Login</Button>
              </Col>
            </Row>

            {this.state.errorMessage && (
              <Row className="mb-3">
                <Col>
                  <Alert key="danger" variant="danger">
                    {this.state.errorMessage}
                  </Alert>
              </Col>  
              </Row>
            )}

          </Col>
          <Col md="4"></Col>
        </Row>
      </Form>
    )
  }
}

// (Login will be exported as the wrapped component below.)

// Helper to inject `location` into class components since hooks can't be used in classes
function withLocation(ComponentClass) {
  return function(props) {
    const location = useLocation();
    return <ComponentClass {...props} location={location} />;
  };
}

export const LoginWithLocation = withLocation(Login);

export default LoginWithLocation;
